import React, { useState } from 'react'
import { GalleryItem } from '../types'
import { usePointManager } from '../../../../hooks/usePointManager'
import { PointInsufficientModal } from '../../../ai-studio/tabs/FashionEditorTab/components/PointInsufficientModal'

interface VideoCreationConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  item: GalleryItem | null
  isLoading?: boolean
}

export const VideoCreationConfirmModal: React.FC<
  VideoCreationConfirmModalProps
> = ({ isOpen, onClose, onConfirm, item, isLoading = false }) => {
  const [showPointModal, setShowPointModal] = useState(false)

  // 900 캐시가 필요한 스타일 클립 생성을 위한 포인트 관리
  const { currentPoint, checkPointsRealtime } = usePointManager({
    requiredPoints: 900,
  })

  if (!isOpen || !item) return null

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const handleConfirm = async () => {
    try {
      // 실시간 포인트 체크
      const hasEnoughPoints = await checkPointsRealtime()

      if (hasEnoughPoints) {
        // 포인트가 충분하면 비디오 생성 진행
        onConfirm()
      } else {
        // 포인트가 부족하면 충전 모달 표시
        setShowPointModal(true)
      }
    } catch (error) {
      console.error('포인트 체크 실패:', error)
      // 에러 발생 시에도 기존 로직대로 진행
      onConfirm()
    }
  }

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleBackdropClick}
    >
      <div className="w-[335px] overflow-hidden rounded-[40px] bg-white shadow-[0px_4px_20px_0px_rgba(0,0,0,0.25)]">
        {/* 상단 콘텐츠 */}
        <div className="px-5 py-8 text-center">
          <h2 className="mb-6 text-[18px] font-bold text-[#222222]">
            스타일 클립 생성
          </h2>
          <p className="text-center text-[14px] leading-[1.57] text-[#5E6068]">
            선택된 스타일 샷으로
            <br />
            스타일 클립을 생성하시겠어요?
            <br />
            9:16 비율의 4초짜리 클립이 생성됩니다.
          </p>
        </div>

        {/* 하단 버튼들 */}
        <div className="flex">
          {/* 취소 버튼 */}
          <button
            onClick={onClose}
            disabled={isLoading}
            className="flex-1 bg-[#EEF1F7] px-[10px] py-[19px] text-[14px] font-bold text-[#5E6068] disabled:opacity-50"
          >
            취소
          </button>

          {/* 생성 버튼 */}
          <button
            onClick={handleConfirm}
            disabled={isLoading}
            className="flex flex-1 items-center justify-center gap-2 bg-[#00B7B9] px-[10px] py-[19px] text-[14px] font-bold text-white disabled:opacity-50"
          >
            {isLoading ? (
              <>
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                생성 중...
              </>
            ) : (
              <>
                <span>생성</span>
                <div className="flex items-center gap-[2px]">
                  {/* 포인트 아이콘 */}
                  <img
                    src="/assets/img/cash.png"
                    alt="cash"
                    className="mr-0.5 h-[13px] w-[11px]"
                  />
                  <span className="text-[14px] font-bold">900</span>
                </div>
              </>
            )}
          </button>
        </div>
      </div>

      {/* 포인트 부족 모달 */}
      <PointInsufficientModal
        isOpen={showPointModal}
        onClose={() => setShowPointModal(false)}
        currentPoint={currentPoint}
        requiredPoint={900}
      />
    </div>
  )
}
